import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import {
    FuseNavigationService,
} from '@fuse/components/navigation';
import { LanguagesService } from './languages-service';



@Component({
    selector: 'languages',
    standalone: true,
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'languages',
    imports: [MatButtonModule, MatMenuModule, NgTemplateOutlet],
})
export class LanguagesComponent{
    langServices = inject(LanguagesService);
    availableLangs = this.langServices.availableLangs$;
    activeLang = this.langServices.currentLang$;

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
    ) {
        //Amplify languages
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the active lang
     *
     * @param lang
     */
    setActiveLang(lang: string): void {
        this.langServices.setLang(lang,true);
    }

    // private _updateNavigation(lang: string): void {
    //     // For the demonstration purposes, we will only update the Dashboard names
    //     // from the navigation but you can do a full swap and change the entire
    //     // navigation data.
    //     //
    //     // You can import the data from a file or request it from your backend,
    //     // it's up to you.

    //     // Get the component -> navigation data -> item
    //     const navComponent =
    //         this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
    //             'mainNavigation'
    //         );

    //     // Return if the navigation component does not exist
    //     if (!navComponent) {
    //         return null;
    //     }

    //     // Get the flat navigation data
    //     const navigation = navComponent.navigation;

    //     // Get the Project dashboard item and update its title
    //     const projectDashboardItem = this._fuseNavigationService.getItem(
    //         'dashboards.project',
    //         navigation
    //     );
    //     if (projectDashboardItem) {
    //         this._translocoService
    //             .selectTranslate('Project')
    //             .pipe(take(1))
    //             .subscribe((translation) => {
    //                 // Set the title
    //                 projectDashboardItem.title = translation;

    //                 // Refresh the navigation component
    //                 navComponent.refresh();
    //             });
    //     }

    //     // Get the Analytics dashboard item and update its title
    //     const analyticsDashboardItem = this._fuseNavigationService.getItem(
    //         'dashboards.analytics',
    //         navigation
    //     );
    //     if (analyticsDashboardItem) {
    //         this._translocoService
    //             .selectTranslate('Analytics')
    //             .pipe(take(1))
    //             .subscribe((translation) => {
    //                 // Set the title
    //                 analyticsDashboardItem.title = translation;

    //                 // Refresh the navigation component
    //                 navComponent.refresh();
    //             });
    //     }
    // }
}
